module.exports = __webpack_public_path__ + "img/item19.d1c72657.png";